// Hora de virada do dia operacional. Casas noturnas fecham de madrugada, então a
// venda das 03:00 pertence à noite do dia anterior: com virada 05:00 o backend
// desloca o date_trunc de dia/mês e a noite inteira cai numa linha só.
//
// Espelha `consolidatedCutoff` em apps/server/src/reports/reports.service.ts:
// vazio/0/fora da faixa 1..23 = desligado (corte à meia-noite).
export const CUTOFF_HOUR_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: '00:00 (padrão)' },
  ...Array.from({ length: 23 }, (_, i) => ({
    value: String(i + 1),
    label: `${String(i + 1).padStart(2, '0')}:00`,
  })),
];
